// Campo de leitura da ficha: rótulo + valor, com fallback visível para vazio.
// Usado nas tabs Dados/Endereço/Banco — mantém o alinhamento e o "—" coerentes
// entre elas, em vez de cada tab inventar o seu.
import { cn } from "@/lib/utils"

type ReadOnlyFieldProps = {
  label: string
  value?: string | null
  // Identificadores (CNPJ, agência/conta) ficam melhores em fonte monoespaçada.
  mono?: boolean
  className?: string
}

export const ReadOnlyField = ({
  label,
  value,
  mono = false,
  className,
}: ReadOnlyFieldProps) => (
  <div className={cn("flex flex-col gap-1", className)}>
    <span className="text-xs font-medium text-muted-foreground">
      {label}
    </span>
    <span
      className={cn(
        "text-sm",
        mono && "font-mono",
        !value && "text-muted-foreground"
      )}
    >
      {value || "—"}
    </span>
  </div>
)
